export enum PropertyCategory { 
        ForSale = 0,
        ToLet = 1,
        NotSet = 99 ,
}

